import { VetSignUpForm } from 'components/Forms';
import { DashboardTitle } from 'components/Titles';
import { Formik } from 'formik';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { vetSignUpValidation } from 'schemas';
import { VetService } from 'services';
import { maskCpf, maskDateFormat, unmaskNumber } from 'util/masks';

import { Grid } from '@mui/material';

export const VetEdit = () => {
  let history: any = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');

  const initialValues = {
    ...history.location.state,
    birthday: maskDateFormat(history.location.state.birthday),
    cpf: maskCpf(history.location.state.cpf),
  };

  const handleSubmit = async (values: any) => {
    const isValid = await vetSignUpValidation.isValid(values);
    setLoading(true);

    const newValues = { ...values, cpf: unmaskNumber(values.cpf) };

    if (isValid) {
      VetService.updateVet(newValues).then(
        ({ data }) => {
          setLoading(false);
          setError('');
          setSuccess(data?.message);
        },
        ({ data }) => {
          setLoading(false);
          setSuccess('');
          setError(data?.error || 'Não foi possível atualizar o veterinário');
        }
      );
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DashboardTitle title="EDITAR VETERINÁRIO" />
      </Grid>
      <Grid item xs={12}>
        <Formik
          initialValues={initialValues}
          validationSchema={vetSignUpValidation}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <VetSignUpForm
              data={{ ...formik.values }}
              loading={loading}
              error={error}
              success={success}
              update
            />
          )}
        </Formik>
      </Grid>
    </Grid>
  );
};

